import { Link } from 'react-router-dom';
import { useLocale } from '@/contexts/LocaleContext';
import { Instagram, Linkedin } from 'lucide-react';
import paletteLogo from '@/assets/palette-logo.png';

export function Footer() {
  const { t, locale } = useLocale();
  const isArabic = locale === 'ar';

  return (
    <footer className="bg-foreground text-background py-6 mt-auto">
      <div className="container mx-auto px-4 max-w-5xl">
        {/* Brand + tagline (centered) */}
        <div className="flex flex-col items-center text-center mb-4">
          <Link to="/" className="flex items-center gap-2 mb-2">
            <img src={paletteLogo} alt="Palette Kuwait logo" className="w-9 h-9 object-contain" />
            <span className="text-lg font-bold">Palette</span>
          </Link>
          <p className="text-background/70 text-sm leading-snug max-w-md">
            {t('footerTagline')}
          </p>
        </div>

        {/* Social icons (centered) */}
        <div className="flex justify-center gap-3 mb-4">
          <a
            href="https://www.instagram.com/palette.kw"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 rounded-full bg-background/10 flex items-center justify-center hover:bg-background/20 transition-colors"
            aria-label="Instagram"
          >
            <Instagram className="w-4 h-4" />
          </a>
          <a
            href="https://www.linkedin.com/company/palette-kw"
            target="_blank"
            rel="noopener noreferrer"
            className="w-9 h-9 rounded-full bg-background/10 flex items-center justify-center hover:bg-background/20 transition-colors"
            aria-label="LinkedIn"
          >
            <Linkedin className="w-4 h-4" />
          </a>
        </div>

        {/* Bottom bar: copyright + about link */}
        <div className="border-t border-background/20 pt-3 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background/60">
          <p>© 2026 {t('allRightsReserved')}</p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link
              to="/cancellation-policy"
              className="hover:text-background transition-colors font-medium"
            >
              {t('cancellationPolicy') || 'سياسة الإلغاء والاسترجاع'}
            </Link>
            <Link
              to="/partner-docs"
              className="hover:text-background transition-colors font-medium"
            >
              {isArabic ? 'للمطورين' : 'Developers'}
            </Link>
            <Link
              to="/about"
              className="hover:text-background transition-colors font-medium"
            >
              {t('about')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
